import { CompanyRepoImpl } from "domain/repository/Company/CompanyRepoImpl";
import { ExchangeRateRepoImpl } from "domain/repository/ExchangeRate/ExchangeRateRepoImpl";
import { MasterDataRepoImpl } from "domain/repository/MasterData/MasterDataRepoImpl";
import { ProposalCopyingForRecalRepoImpl } from "domain/repository/ProposalCopyingForRecal/ProposalCopyingForRecalRepoImpl";
import { StandardProposalItemRepoImpl } from "domain/repository/StandardProposal/StandardProposalItemRepoImpl";
import { StandardProposalRepoImpl } from "domain/repository/StandardProposal/StandardProposalRepoImpl";
import { useProposalCopyingForRecalTracked } from "presentation/store/ProposalCopyingForRecal/ProposalCopyingForRecalProvider";
import { ProposalCopyingForRecalVM } from "presentation/viewModel/ProposalCopyingForRecal/ProposalCopyingForRecalVM";
import { useMemo } from "react";

export const useProposalCopyingForRecalVM = () => {
    const [, setProposalCopyingForRecalState] = useProposalCopyingForRecalTracked();
    const proposalCopyingForRecalVM = useMemo(() =>
        ProposalCopyingForRecalVM({
            dispatch: [setProposalCopyingForRecalState],
            proposalCopyingForRecalRepo: ProposalCopyingForRecalRepoImpl(),
            companyRepo: CompanyRepoImpl(),
            masterDataRepo: MasterDataRepoImpl(),
            standardProposalRepo: StandardProposalRepoImpl(),
            standardProposalItemRepo: StandardProposalItemRepoImpl(),
            exchangeRateRepo: ExchangeRateRepoImpl(),
        }), [setProposalCopyingForRecalState])

    return proposalCopyingForRecalVM
}